var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    _vm.customClass ? _vm.customClass : 'editor-item__delete editor-item__button'
  ]},[_c('span',{on:{"click":function($event){return _vm.show(_vm.id)}}},[_c('i',{staticClass:"icon-icon-trash"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }